import { Injectable } from "@angular/core";
import { AlulaEvent } from "@app/project/model/alula-event";
import { AlulaDatabaseService, AlulaResponseData } from "@app/shared/databases/alula.database";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AlulaEventFilter } from "../model/alula-event";

@Injectable({
    providedIn: "root",
})
export class AlulaEventService {
    deviceEndpoint = "devices";
    eventsEndpoint = "eventlog";

    getEventsByDeviceId(deviceId: string, filters: AlulaEventFilter): Observable<AlulaEvent[]> {
        const { dateEntered, ...rest } = filters;

        let dateFilters = "";
        if (dateEntered?.length > 0) {
            dateEntered.forEach(date => {
                if (date.$gte) {
                    dateFilters += `&filter[dateEntered][$gte]=${date.$gte}`;
                } else if (date.$lte) {
                    dateFilters += `&filter[dateEntered][$lte]=${date.$lte}`;
                }
            });
        }
        return this.alulaDatabaseService
            .getRecords$(this.deviceEndpoint + `/${deviceId}/` + this.eventsEndpoint, rest, "-dateEntered", dateFilters)
            .pipe(
                map((events: AlulaResponseData[]) => events.map(eventData => AlulaEvent.fromDbObject(eventData))),
                catchError(DataServiceError.handleError())
            );
    }

    constructor(private alulaDatabaseService: AlulaDatabaseService) {}
}
